import { MainLayout } from '@templates/index';
import { LEGAL_CONFIG } from '@/config/legal';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto py-12 px-4">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Gizlilik Politikası ve KVKK Aydınlatma Metni
          </h1>
          <p className="text-gray-500 text-sm mb-8">
            Son Güncelleme Tarihi: {LEGAL_CONFIG.lastUpdated}
          </p>

          {/* Bölüm 1 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Veri Sorumlusu</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              6698 sayılı Kişisel Verilerin Korunması Kanunu (&quot;KVKK&quot;) uyarınca, kişisel
              verileriniz; veri sorumlusu olarak{' '}
              <strong>{LEGAL_CONFIG.companyName}</strong> (&quot;Lezzet Yolda&quot; veya
              &quot;Şirket&quot;) tarafından aşağıda açıklanan kapsamda işlenebilecektir.
            </p>
            <ul className="list-none pl-0 space-y-1 text-gray-700">
              <li>
                <strong>Unvan:</strong> {LEGAL_CONFIG.companyName}
              </li>
              <li>
                <strong>MERSİS No:</strong> {LEGAL_CONFIG.mersisNo}
              </li>
              <li>
                <strong>Vergi Kimlik No:</strong> {LEGAL_CONFIG.taxNumber}
              </li>
              <li>
                <strong>Adres:</strong> {LEGAL_CONFIG.fullAddress}
              </li>
              <li>
                <strong>E-posta:</strong>{' '}
                <a href={`mailto:${LEGAL_CONFIG.email}`} className="text-primary hover:underline">
                  {LEGAL_CONFIG.email}
                </a>
              </li>
            </ul>
          </section>

          {/* Bölüm 2 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              2. Kişisel Verilerin Hangi Amaçla İşleneceği
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Toplanan kişisel verileriniz, KVKK&apos;nın 5. ve 6. maddelerinde belirtilen kişisel
              veri işleme şartları ve amaçları dahilinde aşağıdaki amaçlarla işlenecektir:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>
                <strong>Hizmetlerin Sunulması:</strong> Üyelik işlemlerinin gerçekleştirilmesi,
                platform üzerinden sipariş vermenizin sağlanması, siparişlerin restoranlar ile
                paylaşılması ve takibinin yapılması.
              </li>
              <li>
                <strong>Ödeme Süreçleri:</strong> Sipariş bedellerinin tahsilatı,
                faturalandırma ve finansal mutabakatların sağlanması.
              </li>
              <li>
                <strong>Teslimat Süreçleri:</strong> Siparişlerinizin size ulaştırılması için
                konum bilgilerinizin işlenmesi ve kuryelerle paylaşılması.
              </li>
              <li>
                <strong>İletişim ve Destek:</strong> Talep, şikayet ve önerilerinizin alınması,
                yanıtlanması ve müşteri memnuniyetinin sağlanması.
              </li>
              <li>
                <strong>Pazarlama ve Tanıtım:</strong> (Açık rıza vermeniz halinde) Genel veya
                size özel kişiselleştirilmiş kampanyalar, avantajlar, promosyonlar ve
                bilgilendirmeler.
              </li>
              <li>
                <strong>Yasal Yükümlülükler:</strong> Vergi Usul Kanunu, Türk Ticaret Kanunu,
                Tüketicinin Korunması Hakkında Kanun vb. mevzuat uyarınca yasal
                yükümlülüklerin yerine getirilmesi.
              </li>
              <li>
                <strong>Güvenlik ve İyileştirme:</strong> Platformun güvenliğinin sağlanması,
                suistimallerin önlenmesi ve kullanıcı deneyiminin iyileştirilmesi.
              </li>
            </ul>
          </section>

          {/* Bölüm 3 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              3. İşlenen Kişisel Veri Kategorileri
            </h2>
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-200 rounded-lg text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">
                      Veri Kategorisi
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">
                      Örnek Veriler
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">
                      Hukuki Sebep (KVKK m.5)
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="px-4 py-3 text-gray-700">Kimlik Bilgileri</td>
                    <td className="px-4 py-3 text-gray-700">Ad, soyad</td>
                    <td className="px-4 py-3 text-gray-700">Sözleşmenin ifası, meşru menfaat</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-gray-700">İletişim Bilgileri</td>
                    <td className="px-4 py-3 text-gray-700">E-posta, cep telefonu, teslimat adresi</td>
                    <td className="px-4 py-3 text-gray-700">Sözleşmenin ifası, açık rıza</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-gray-700">Lokasyon Bilgileri</td>
                    <td className="px-4 py-3 text-gray-700">Anlık veya kayıtlı konum bilgisi</td>
                    <td className="px-4 py-3 text-gray-700">Sözleşmenin ifası</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-gray-700">Müşteri İşlem Bilgileri</td>
                    <td className="px-4 py-3 text-gray-700">
                      Sipariş geçmişi, favori ürünler, talep ve şikayet kayıtları, fatura bilgileri
                    </td>
                    <td className="px-4 py-3 text-gray-700">Sözleşmenin ifası, yasal yükümlülük</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-gray-700">Finansal Bilgiler</td>
                    <td className="px-4 py-3 text-gray-700">
                      Kredi kartı son 4 hanesi, ödeme detayları (ham kart bilgisi saklanmaz)
                    </td>
                    <td className="px-4 py-3 text-gray-700">Sözleşmenin ifası</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-gray-700">Pazarlama Bilgileri</td>
                    <td className="px-4 py-3 text-gray-700">
                      Çerez kayıtları, hedefleme bilgileri, kampanya katılım bilgileri
                    </td>
                    <td className="px-4 py-3 text-gray-700">Açık rıza, meşru menfaat</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-gray-700">Teknik Veriler</td>
                    <td className="px-4 py-3 text-gray-700">IP adresi, cihaz bilgisi, tarayıcı</td>
                    <td className="px-4 py-3 text-gray-700">Meşru menfaat, yasal yükümlülük</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Bölüm 4 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              4. Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verileriniz, KVKK&apos;nın 8. ve 9. maddelerine uygun olarak aşağıdaki
              taraflara aktarılabilecektir:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>
                <strong>Üye İşyerleri (Restoranlar):</strong> Siparişin hazırlanması ve doğru
                teslimat için ad, soyad, telefon ve adres bilgileriniz paylaşılır.
              </li>
              <li>
                <strong>Kuryeler / Teslimat Şirketleri:</strong> Teslimat için ad, soyad, telefon
                ve adres bilgileriniz paylaşılır.
              </li>
              <li>
                <strong>Ödeme Hizmeti Sağlayıcıları:</strong> Güvenli ödeme işlemleri için
                finansal bilgileriniz lisanslı kuruluşlara (ör. Iyzico) aktarılır; kart
                bilgileri tokenize edilir.
              </li>
              <li>
                <strong>Tedarikçiler ve İş Ortakları:</strong> Teknik altyapı ve pazarlama
                hizmetleri için hizmetin gerektirdiği ölçüde paylaşılabilir.
              </li>
              <li>
                <strong>Yetkili Kamu Kurum ve Kuruluşları:</strong> Yasal zorunluluk halinde
                mahkeme kararı veya yasal talep doğrultusunda paylaşılabilir.
              </li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Verileriniz yurt dışına aktarılacaksa, KVKK m.9 uyarınca yeterli koruma sağlanan
              ülkelere veya yeterli koruma taahhüdü veren alıcılara aktarılır.
            </p>
          </section>

          {/* Bölüm 5 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              5. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verileriniz, Lezzet Yolda web sitesi ve mobil uygulaması üzerinden
              elektronik ortamda; sipariş formları, üyelik formları, çerezler ve benzeri kanallar
              aracılığıyla toplanmaktadır. Bu veriler KVKK Madde 5 uyarınca;
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması,</li>
              <li>
                Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması,
              </li>
              <li>
                İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla veri
                sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması
              </li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              hukuki sebeplerine dayalı olarak veya açık rızanızın alınması suretiyle
              işlenmektedir.
            </p>
          </section>

          {/* Bölüm 6 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              6. Veri Saklama Süreleri
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca ve yasal saklama
              yükümlülükleri (ticari defterler 10 yıl, vergi mevzuatı vb.) dikkate alınarak
              saklanır. Amaç ortadan kalktığında veriler silinir, anonimleştirilir veya imha
              edilir.
            </p>
          </section>

          {/* Bölüm 7 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Veri Güvenliği</h2>
            <p className="text-gray-700 leading-relaxed">
              Verilerinizin güvenliği için teknik ve idari tedbirler alınmaktadır: şifreleme
              (SSL/TLS), güvenli ödeme altyapısı (PCI-DSS), erişim kısıtlamaları ve düzenli
              güvenlik değerlendirmeleri. Kredi kartı bilgileri ham haliyle kesinlikle
              saklanmamaktadır.
            </p>
          </section>

          {/* Bölüm 8 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              8. İlgili Kişinin Hakları (KVKK Madde 11)
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              KVKK&apos;nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:
            </p>
            <ul className="list-[lower-alpha] pl-6 space-y-2 text-gray-700">
              <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
              <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
              <li>
                Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp
                kullanılmadığını öğrenme,
              </li>
              <li>
                Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri
                bilme,
              </li>
              <li>
                Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların
                düzeltilmesini isteme,
              </li>
              <li>
                KVKK&apos;nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin
                silinmesini veya yok edilmesini isteme,
              </li>
              <li>
                Düzeltme ve silme işlemlerinin kişisel verilerin aktarıldığı üçüncü kişilere
                bildirilmesini isteme,
              </li>
              <li>
                İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi
                suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,
              </li>
              <li>
                Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması
                hâlinde zararın giderilmesini talep etme.
              </li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Bu haklarınızı kullanmak için{' '}
              <a href={`mailto:${LEGAL_CONFIG.email}`} className="text-primary hover:underline font-medium">
                {LEGAL_CONFIG.email}
              </a>{' '}
              adresine yazılı olarak başvurabilirsiniz. Talebiniz en geç 30 gün içinde
              sonuçlandırılacaktır.
            </p>
          </section>

          {/* Bölüm 9 — Ticari İleti */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              9. Ticari Elektronik İleti ve Açık Rıza
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Platforma üye olarak ve/veya ilgili onayı vererek, tarafınıza özel kampanyalar,
              indirimler, promosyonlar ve pazarlama içeriklerinin; SMS, e-posta, mobil bildirim
              ve arama gibi ticari elektronik iletişim araçlarıyla gönderilmesine rıza
              göstermiş olursunuz.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Bu rızanızı dilediğiniz zaman, size gönderilen iletilerdeki ret bildirim linkini
              kullanarak veya platform üzerindeki ayarlar bölümünden geri alabilirsiniz.
            </p>
          </section>

          {/* Bölüm 10 — Çerezler */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Çerezler (Cookies)</h2>
            <p className="text-gray-700 leading-relaxed">
              Platform ve web sitemiz, hizmet kalitesini artırmak, oturum yönetimi ve analitik
              amaçlarla çerez kullanmaktadır. Zorunlu çerezler hizmetin sunulması için
              gereklidir. İsteğe bağlı çerezler için tercihlerinizi ayarlayabilirsiniz.
              Detaylı bilgi için{' '}
              <Link to="/cookies" className="text-primary hover:underline font-medium">
                Çerez Politikamızı
              </Link>{' '}
              inceleyebilirsiniz.
            </p>
          </section>

          {/* Bölüm 11 — Değişiklikler */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Değişiklikler</h2>
            <p className="text-gray-700 leading-relaxed">
              Gizlilik Politikası ve Aydınlatma Metni güncellendiğinde, değişiklikler platform
              üzerinden duyurulacaktır. Önemli değişikliklerde e-posta ile bilgilendirme
              yapılabilir.
            </p>
          </section>

          {/* Bölüm 12 — İletişim */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">12. İletişim</h2>
            <ul className="list-none pl-0 space-y-1 text-gray-700">
              <li>
                <strong>E-posta:</strong>{' '}
                <a href={`mailto:${LEGAL_CONFIG.email}`} className="text-primary hover:underline">
                  {LEGAL_CONFIG.email}
                </a>
              </li>
              <li>
                <strong>Adres:</strong> {LEGAL_CONFIG.fullAddress}
              </li>
            </ul>
          </section>

          <div className="mt-12 pt-8 border-t border-gray-200 flex flex-wrap gap-4">
            <Link to="/terms" className="text-primary hover:underline font-medium">
              Kullanım Koşulları
            </Link>
            <Link to="/cookies" className="text-primary hover:underline font-medium">
              Çerez Politikası
            </Link>
            <Link to="/" className="text-primary hover:underline font-medium">
              ← Ana Sayfaya Dön
            </Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default PrivacyPage;
